export default "__VITE_ASSET__CIOqpxUH__"